import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";
import { useIntl } from "react-intl";

import { isNotEmpty } from "@mapmycustomers/shared/util/assert";

const FrequencyDaysLeftCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const intl = useIntl();

  if (!isNotEmpty(value)) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  const isOverdue = value > 0;

  return (
    <div>
      {intl.formatMessage(
        {
          id: "frequencyDaysLeft.value",
          defaultMessage:
            "{days} {days, plural, one {day} other {days}} {isOverdue, select, true {over} other {left in}} frequency",
          description: "Overdue value formatter for Frequency Days Left",
        },
        { days: isOverdue ? value : -value, isOverdue }
      )}
    </div>
  );
};

export default FrequencyDaysLeftCellRenderer;
